module.exports = __webpack_public_path__ + "img/cir2.960044af.png";